import { useCallback, useEffect, useState } from 'react';
import { isDonationAlreadyPaidError } from './donationCheckoutUtils';

export const DONATION_ALREADY_PAID_NOTICE =
  'This donation has already been completed. Taking you to the confirmation page…';

/** Shows an inline notice and redirects to the finish step after a short delay. */
export function useDonationAlreadyPaidHandler(onAlreadyPaid) {
  const [showNotice, setShowNotice] = useState(false);

  const handleMutationError = useCallback((error) => {
    if (isDonationAlreadyPaidError(error)) {
      setShowNotice(true);
      return true;
    }
    return false;
  }, []);

  useEffect(() => {
    if (!showNotice) {
      return undefined;
    }
    const timer = window.setTimeout(() => onAlreadyPaid?.(), 1500);
    return () => window.clearTimeout(timer);
  }, [showNotice, onAlreadyPaid]);

  return {
    showNotice,
    handleMutationError,
    noticeMessage: DONATION_ALREADY_PAID_NOTICE,
  };
}
